<template>
  <div>
    <section class="intro-single">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-10">
            <div class="title-single-box"><h1 class="title-single">Laboratory of
              Affective Sensory Research</h1><span
              class="color-text-a">LASR: Focus on Autism</span></div>
          </div>
          <div class="col-md-12 col-lg-2">
            <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/"
                                               class="router-link-exact-active router-link-active">Home</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section class="news-single nav-arrow-b">
      <div class="container">
        <div class="row">
          <div class="col-sm-8">
            <div class="news-img-box"><img src="/static/img/pic-home.jpg" alt=""
                                           class="img-fluid home-image"></div>
            <div class="post-content color-text-a"><p>The goal of our lab is to
              progress toward a better understanding of
              autism spectrum disorders, by
              investigating the brain bases of sensory processing differences and repetitive
              behaviors. Autism
              spectrum disorders are a group of neurodevelopmental disorders that affect communication
              and social
              interactions, and are characterized by restricted or repetitive patterns of behavior.
              Autism is
              estimated to affect 1 in 59 children, and has a profound impact on affected individuals
              and their
              families and communities.</p>
              <p>We use a combination of behavioral and neuroscience methods to learn more about
                sensation,
                perception, emotion, and special interests in children and adults with autism. We also
                study infants
                who have a sibling with an autism spectrum disorder and thus are at a higher risk of
                developing
                autism. Our methods include functional magnetic resonance imaging (fMRI), diffusion
                tensor imaging
                (DTI), psychophysics, observational measures, and electroencephalography (EEG).
              </p>
              <p>We hope that learning more about the interaction of sensory and emotional
                processes in
                the brain will
                provide important clues to the patterns of social difficulties and repetitive behaviors
                seen in
                autism.We’re grateful to the families and individuals who volunteer their time to our
                research
                studies, as well as to the following sources of funding:</p>
              <ul>
                <li>National Institute of Mental Health (NIMH)</li>
                <li>Autism Science Foundation</li>
                <li>Vanderbilt Clinical and Translational Research Center</li>
                <li>Autism Speaks</li>
                <li>International Society for Autism Research (INSAR) Innovation in Autism Research
                  Award<br></li>
                <li>The Carrell Family Discovery Grant, awarded by the Nicholas Hobbs Society</li>
                <li>The Landreth Family Discovery Grant</li>
                <li>The Marino Autism Research Institute<br></li>
              </ul>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="alert alert-info"><h5>Visiting the Lab?</h5>
              <p>If your appointment is at the Village at Vanderbilt, you can either park
                in the lot behind the Village at Vanderbilt or on the first floor of the Village's parking garage,
                the entrance is located just behind the parking lot. You do not need a ticket for either parking lot.
              </p>
              <p>If your appointment is at the Vanderbilt University Medical Center Institute of
                Imaging Science, you can
                park in the East Garage. Bring your ticket to your appointment to have it validated. You
                may also choose to use the free valet parking service in this garage.</p><a
                href="http://www.vanderbilt.edu/map/"
                target="_blank">Map of
                Vanderbilt</a></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Home"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue